"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@web3-react/core");
const collection_card_1 = require("@components/collection-card");
const button_1 = require("@shared-modules/components/button");
const loader_1 = require("@shared-modules/components/loader");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const stub_cards_1 = require("@components/stub-cards");
const collection_hooks_1 = require("@hooks/collection.hooks");
const PREVIEW_TOKENS_AMOUNT = 3;
const ProfileCollectionsPage = () => {
    const { account } = (0, core_1.useWeb3React)();
    const { params: { id: profileAccount = account || "" }, } = (0, react_router_dom_1.useRouteMatch)();
    const { list: collections, nextPage, isFirstLoadCompleted, isLastPage, loaderState: { total }, } = (0, collection_hooks_1.useCollections)({ creator: profileAccount, sorting: "desc" });
    const translator = (0, translation_hooks_1.usePagesTranslation)("profileCollectionsPage");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    return (React.createElement("div", { className: "p-profile-collections-page" },
        !isFirstLoadCompleted && (React.createElement("div", { className: "p-profile-collections-page__loader" },
            React.createElement(loader_1.Loader, { scale: 1 }))),
        isFirstLoadCompleted && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "p-profile-collections-page__container" },
                collections.map((collection) => (React.createElement(collection_card_1.CollectionCard, { key: collection.id, collection: collection }))),
                React.createElement(stub_cards_1.StubCards, null)),
            isLastPage && total === 0 && (React.createElement("div", { className: "p-profile-collections-page__empty" }, translator("emptyList"))),
            !isLastPage && (React.createElement("div", { className: "p-profile-collections-page__button" },
                React.createElement(button_1.Button, { type: "thirtery", onClick: nextPage }, commonTranslator("loadMoreButton"))))))));
};
exports.default = ProfileCollectionsPage;
